import state from './moduleAdSchedulesState'
import mutations from './moduleAdSchedulesMutations'
import actions from './moduleAdSchedulesActions'
import getters from './moduleAdSchedulesGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
